import { render, staticRenderFns } from "./OtpSwitch.vue?vue&type=template&id=14576862&scoped=true"
import script from "./OtpSwitch.vue?vue&type=script&lang=ts"
export * from "./OtpSwitch.vue?vue&type=script&lang=ts"
import style0 from "./OtpSwitch.vue?vue&type=style&index=0&id=14576862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../pwa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14576862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VChip,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VForm,VTab,VTabItem,VTabs,VTabsItems})
